import { createSlice } from '@reduxjs/toolkit';

import { getGlobalParam } from '@agilemd/ui-utils';

import reexportSelector from '../utils/reexportSelector.js';
import { reset } from './actions.js';

const {
  cptCode,
  cptDescription,
  cptLabel,
  procedureEventRate,
  procedureFrequency,
  hemorrhageFrequency,
  readmissionFrequency,
  notHomeFrequency,
  procedureRelativeValueUnits
} = getGlobalParam('questionValues');
const initialState = {
  cptCode,
  cptDescription,
  cptLabel,
  procedureEventRate,
  procedureFrequency,
  hemorrhageFrequency,
  readmissionFrequency,
  notHomeFrequency,
  procedureRelativeValueUnits
};
const reexport = reexportSelector('procedure');

export const procedureSlice = /** @type {import('@reduxjs/toolkit').Slice} */ (
  createSlice({
    name: 'procedure',
    initialState,
    reducers: {
      setProcedure: (_s, { payload: value }) => value,
      resetProcedure: () => ({
        cptCode: null,
        cptDescription: null,
        cptLabel: null,
        procedureEventRate: null,
        procedureFrequency: null,
        hemorrhageFrequency: null,
        readmissionFrequency: null,
        notHomeFrequency: null,
        procedureRelativeValueUnits: null
      })
    },
    extraReducers: {
      [reset]: () => ({
        cptCode: null,
        cptDescription: null,
        cptLabel: null,
        procedureEventRate: null,
        procedureFrequency: null,
        hemorrhageFrequency: null,
        readmissionFrequency: null,
        notHomeFrequency: null,
        procedureRelativeValueUnits: null
      })
    }
  })
);

export const { setProcedure, resetProcedure } = procedureSlice.actions;

export const hasSelectedProcedure = reexport(state => Boolean(state.cptCode));
export const getProcedureCptCode = reexport(state => state.cptCode || null);
export const getProcedure = reexport(state => ({
  cptCode: state.cptCode,
  cptDescription: state.description,
  cptLabel: state.label,
  procedureEventRate: state.procedureEventRate,
  procedureFrequency: state.procedureFrequency,
  hemorrhageFrequency: state.hemorrhageFrequency,
  readmissionFrequency: state.readmissionFrequency,
  notHomeFrequency: state.notHomeFrequency,
  procedureRelativeValueUnits: state.procedureRelativeValueUnits
}));

export default procedureSlice.reducer;
